import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function Footer() {
  return (
    <footer className="footer" style={{ padding: "20px 0" }}>
      <Container>
        <Row>
          <Col md={4}>
            <h5>Kontakt</h5>
            <div className="footer-phone-email">
              <a href="mailto:sales@devopscrafts.com">sales@devopscrafts.com</a>
            </div>
          </Col>
          <Col md={4} className="footer-address-col">
            <h5>Adresa</h5>
            <p>DevOps Crafts doo</p>
            <p>Crnogorska 9</p>
            <p>32300 Gornji Milanovac</p>
            <p>Srbija</p>
          </Col>
          <Col md={4}>
            <h5>Website</h5>
            <a
              href="https://devopscrafts.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              DevOps Crafts
            </a>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="text-center">
            <p>
              &copy; {new Date().getFullYear()} DevOps Crafts - All Rights
              Reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
